export const LOAD_FOLDER_SUCCESS = "LOAD_FOLDER_SUCCESS";
export const LOAD_FOLDER_VISIBILITY_LEVELS_SUCCESS = "LOAD_FOLDER_VISIBILITY_LEVELS_SUCCESS";
export const LOAD_OFFER_VISIBILITY_LEVELS_SUCCESS = "LOAD_OFFER_VISIBILITY_LEVELS_SUCCESS";

export const LOAD_FOLDER_USER_PREFERENCES_SUCCESS = "LOAD_FOLDER_USER_PREFERENCES_SUCCESS";
export const LOAD_FOLDER_SELECTED_USER_PREFERENCE_SUCCESS = "LOAD_FOLDER_SELECTED_USER_PREFERENCE_SUCCESS";
export const LOAD_FOLDER_DEFAULT_USER_PREFERENCE_SUCCESS = "LOAD_FOLDER_DEFAULT_USER_PREFERENCE_SUCCESS";
export const UPDATE_FOLDER_USER_PREFERENCES_SUCCESS = "UPDATE_FOLDER_USER_PREFERENCES_SUCCESS";
export const UPDATE_FOLDER_SELECTED_USER_PREFERENCE_SUCCESS = "UPDATE_FOLDER_SELECTED_USER_PREFERENCE_SUCCESS";

export const LOAD_RESPONSIBLE_FOLDERS_STARTED = "LOAD_RESPONSIBLE_FOLDERS_STARTED";
export const LOAD_RESPONSIBLE_FOLDERS_SUCCEEDED = "LOAD_RESPONSIBLE_FOLDERS_SUCCEEDED";
export const LOAD_RESPONSIBLE_FOLDERS_FAILED = "LOAD_RESPONSIBLE_FOLDERS_FAILED";

export const UPDATE_RESPONSIBLE_FOLDERS_STARTED = "UPDATE_RESPONSIBLE_FOLDERS_STARTED";
export const UPDATE_RESPONSIBLE_FOLDERS_SUCCEEDED = "UPDATE_RESPONSIBLE_FOLDERS_SUCCEEDED";
export const UPDATE_RESPONSIBLE_FOLDERS_FAILED = "UPDATE_RESPONSIBLE_FOLDERS_FAILED";

export const REFRESH_RESPONSIBLE_FOLDERS = "REFRESH_RESPONSIBLE_FOLDERS";
